import axios from "axios";

export function getClassZoomList(data) {
  const config = {
    params: data,
  };
  return axios.get(process.env.VUE_APP_API_URL + "ClassZoom/GetList", config);
}
